// frontend/src/askos/SubjectProgressCard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { askosAuthHeader } from './askosApi';

const SubjectProgressCard = ({ slug }) => {
    const [subjects, setSubjects] = useState([]);
    const [overallPct, setOverallPct] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        Promise.all([
            api.get(`/tenant/${slug}/askos/progress/subjects`, { headers: askosAuthHeader() }),
            api.get(`/tenant/${slug}/askos/progress/overall`, { headers: askosAuthHeader() }),
        ])
            .then(([subjectsRes, overallRes]) => {
                setSubjects(subjectsRes.data || []);
                setOverallPct(overallRes.data?.overall_pct ?? null);
            })
            .catch(() => { setSubjects([]); setOverallPct(null); })
            .finally(() => setLoading(false));
    }, [slug]);

    return (
        <article className="panel subject-progress">
            <div className="panel-heading">
                <h3>Subject Progress</h3>
                {overallPct != null && <span>{Math.round(overallPct)}%</span>}
            </div>

            {loading && <p className="empty-note">Loading…</p>}
            {!loading && subjects.length === 0 && <p className="empty-note">No subjects yet — start a chat to begin tracking progress.</p>}

            <div className="subject-grid">
                {subjects.map(s => (
                    <div key={s.project_id} className="subject-card">
                        <strong>{s.subject}</strong>
                        <div className="ring" style={{ '--value': Math.round(s.completion_pct) }}>
                            <span>{Math.round(s.completion_pct)}%</span>
                        </div>
                        <small>{s.strength}</small>
                    </div>
                ))}
            </div>

            <a className="panel-link" href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/performance'); }}>View Detailed Progress →</a>
        </article>
    );
};

export default SubjectProgressCard;
